module.exports = __webpack_public_path__ + "images/thumb-down-filledb7ea44867b4512a95e2233fd6e61a28a.svg";